import { Group } from '@mantine/core';
import { useCallback } from 'react';
import IconButton from '@ui/components/IconButton/IconButton';
import EmailChipsInput from '@ui/components/EmailChipsInput/EmailChipsInput';
import ProjectMemberRoleSelector, { RoleOption } from '@projectMembers/components/ProjectMembersList/ProjectMemberRoleSelector/ProjectMemberRoleSelector';
import ProjectRole, { ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';

import styles from './EmailsInput.module.scss';

type EmailsInputProps = {
	emails: string[];
	role: ProjectRole;
	roleOptions: RoleOption[];
	emailValidator: ( email: string ) => boolean;
	onEmailsChange: ( emails: string[] ) => void;
	onRoleChange: ( role: ProjectRole ) => void;
	onAddGroupClick?: () => void;
};

const EmailsInput = ( {
	emails, role, roleOptions, emailValidator, onEmailsChange, onRoleChange, onAddGroupClick
}: EmailsInputProps ) => {
	const onRoleChanged = useCallback( ( roleType: ProjectMemberRoleType ) => {
		const newRole = ProjectRole.fromID( roleType );
		if ( newRole ) onRoleChange( newRole );
	}, [ onRoleChange ] );

	return (
		<Group
			className={styles.EmailsInputWrapper}
			position="apart"
			noWrap
			spacing={12}
			align="flex-start"
		>
			<EmailChipsInput
				emails={emails}
				onEmailsChange={onEmailsChange}
				emailValidator={emailValidator}
			/>
			<Group h={30} align="center" spacing={8}>
				<ProjectMemberRoleSelector
					selectedRole={role}
					roleOptions={roleOptions}
					showDelete={false}
					onChange={onRoleChanged}
				/>
				<Tooltip title="Add group">
					<IconButton
						icon="perm-contact-calendar-outlined"
						size={18}
						variant="transparent"
						color="dark.3"
						onClick={onAddGroupClick}
					/>
				</Tooltip>
			</Group>
		</Group>
	);
};

export default EmailsInput;
